const CLEAN = (state) => {
  state.shipping = {
    address: {
      destination: {
        postalCode: state.shipping.address.destination.postalCode
      }
    },
    currentService: {},
    services: [],
    price: null
  }
}

const SET_DESTINATION_POSTAL_CODE = (state, destinationPostalCode) => {
  state.shipping.address.destination.postalCode = destinationPostalCode
}

const SET_SERVICES = (state, { destinationAddress, services }) => {
  state.shipping.services = services

  state.shipping.address.destination.city = destinationAddress.city
  state.shipping.address.destination.street = destinationAddress.street
  state.shipping.address.destination.state = destinationAddress.state
}

const SET_CURRENT_SERVICE = (state, service) => {
  state.shipping = {
    ...state.shipping,
    currentService: service,
    price: service.value
  }
}

export default {
  CLEAN,
  SET_DESTINATION_POSTAL_CODE,
  SET_SERVICES,
  SET_CURRENT_SERVICE
}
